export default {
  // Hero
  'archive.hero.kicker': 'Tate Protest präsentiert',
  'archive.hero.title': 'DAS ARCHIV',
  'archive.hero.subtitle': 'Der Bericht ist auf Band',
  'archive.hero.accessing': 'VIDEOARCHIV WIRD GELADEN_',
  'archive.hero.selectScreen': 'BILDSCHIRM AUSWÄHLEN',
  'archive.featured.eyebrow': 'Empfohlenes Video',
  'archive.featured.selectedEyebrow': 'Ausgewähltes Video',
  'archive.featured.unavailableTitle': 'Empfohlenes Band nicht verfügbar',
  'archive.featured.unavailableBody': 'Das hervorgehobene Archivband ist momentan nicht verfügbar. Wähle unten an der TV-Wand ein anderes Band aus.',

  // Tür des Architekten
  'archive.door.enter': 'Betritt die Matrix',

  // TV-Bildschirme
  'archive.tv.accessDenied': 'ZUGRIFF VERWEIGERT',

  // Terminalstatus + CTA (Seitenfuß)
  'archive.status.active': 'ARCHIVSTATUS: AKTIV',
  'archive.status.newTapes': 'NEUE BÄNDER WERDEN HINZUGEFÜGT, WÄHREND DIE VERFAHREN VORANSCHREITEN',
  'archive.cta.description': 'Diese Archivbänder sind Teil der dokumentarischen Aufzeichnungen von Tate Protest. Für die vollständige Rechts-Zeitachse und die Falldokumentation besuche direkt die Fallseiten.',
  'archive.cta.legalTimeline': 'Rechts-Zeitachse',
  'archive.cta.evidence': 'Beweisübersicht',
  'archive.cta.getInvolved': 'Mach mit',

  // Videoplayer
  'archive.player.subtitles': 'Untertitel',
  'archive.player.ccOff': 'Untertitel ausschalten',
  'archive.player.ccEn': 'Englische Untertitel',
  'archive.player.ccEs': 'Subtítulos en español',
  'archive.player.ccDe': 'Deutsche Untertitel',
  'archive.player.archiveFootage': 'ARCHIVAUFNAHMEN',
  'archive.player.sourcePending': 'QUELLE AUSSTEHEND',
  'archive.player.sourcePreparing': 'Die Videoquelle wird für die Einfügung ins Archiv vorbereitet.',
  'archive.player.tape': 'BAND',
  'archive.player.originalSource': 'Originalquelle',
  'archive.player.viewSource': 'Quelle ansehen',
  'archive.player.copied': 'Kopiert',
  'archive.player.share': 'Teilen',
  'archive.player.close': 'ARCHIV SCHLIESSEN',
  'archive.player.rewind': '10 s zurück',
  'archive.player.forward': '10 s vor',
  'archive.player.play': 'Video abspielen',
  'archive.player.pause': 'Video pausieren',
  'archive.player.volume': 'Videolautstärke',
  'archive.player.fullscreen': 'Vollbild öffnen',

  // Gemeinsame Kategorien
  'archive.categories.investigation': 'Ermittlung',
  'archive.categories.newsReport': 'Nachrichtenbericht',
  'archive.categories.parliamentaryDebate': 'Parlamentsdebatte',
  'archive.categories.legalProceedings': 'Gerichtsverfahren',
  'archive.categories.witnessStatement': 'Zeugenaussage',
  'archive.categories.civilLitigation': 'Zivilverfahren',
  'archive.categories.expertCommentary': 'Expertenkommentar',
  'archive.categories.movementHistory': 'Geschichte der Bewegung',
  'archive.categories.pressArchive': 'Pressearchiv',
  'archive.categories.demonstrationArchive': 'Demonstrationsarchiv',
  'archive.categories.interview': 'Interview',

  // Gemeinsame Daten
  'archive.dates.april2022': 'April 2022',
  'archive.dates.april122022': '12. April 2022',
  'archive.dates.august282022': '28. August 2022',
  'archive.dates.december2022': 'Dezember 2022',
  'archive.dates.january192023': '19. Januar 2023',
  'archive.dates.january2024': 'Januar 2024',
  'archive.dates.2025Present': '2025 — heute',
  'archive.dates.romanianProceedings': 'Verfahren in Rumänien',
  'archive.dates.2024Present': '2024 — heute',
  'archive.dates.2023Present': '2023 — heute',
  'archive.dates.ongoing': 'Laufend',
  'archive.dates.2022Present': '2022 — heute',
  'archive.dates.preArrest': 'Aufnahme vor der Festnahme',
  'archive.dates.august272026': '26. August 2026',
  'archive.dates.august282026': '27. August 2026',

  // Labels verwandter Fälle
  'archive.related.viewRomania': 'Fall Rumänien ansehen',
  'archive.related.viewMatrix': 'Matrix-Angriff ansehen',
  'archive.related.viewUk': 'Fall Vereinigtes Königreich ansehen',
  'archive.related.viewUs': 'Fall USA ansehen',
  'archive.related.viewJaneDoe': 'Fall Jane Doe ansehen',
  'archive.related.viewPencov': 'Fall Pencov v. Doe ansehen',
  'archive.related.viewOnlineDefamation': 'Verfahren zur Kontenoffenlegung gegen X ansehen',
  'archive.related.viewEvidence': 'Beweise ansehen',
  'archive.related.aboutTates': 'Über die Tates',
  'archive.related.getInvolved': 'Mach mit',
  'archive.related.viewArchive': 'Das Archiv ansehen',

  // Video 001
  'archive.videos.latest-development.title': 'DIICOT-Razzia auf Andrew Tates Überwachungskamera festgehalten — April 2022',
  'archive.videos.latest-development.description': 'Die Überwachungskamera von Andrew Tates eigenem Anwesen hält fest, wie rumänische DIICOT-Beamte die Immobilie im April 2022 durchsuchen. Die Beamten beschlagnahmten Computer, Kameras und alle elektronischen Geräte des Anwesens als Teil der ersten strafrechtlichen Ermittlungen.',

  // Video 002
  'archive.videos.diicot-seizure.title': 'DIICOT beschlagnahmte alles — Andrew Tate, 12. April 2022',
  'archive.videos.diicot-seizure.description': 'Andrew Tate dokumentiert, dass DIICOT alle Computer, Kameras und elektronischen Geräte des Anwesens beschlagnahmt hatte. Persönliche Aufnahmen, die die Folgen der Razzia vom April 2022 zeigen — jedes Gerät, das von den rumänischen Behörden konfisziert wurde.',

  // Video 003
  'archive.videos.andrew-schulz-cancelled.title': 'Andrew Schulz spricht über die Löschung von Andrew Tate — 28. August 2022',
  'archive.videos.andrew-schulz-cancelled.description': 'Comedian Andrew Schulz spricht über die Löschung von Andrew Tate im August 2022. Schulz untersucht die Deplatforming-Kampagne, die koordinierten Social-Media-Sperren und die weiterreichenden Folgen für Meinungsfreiheit und digitale Zensur.',

  // Video 004
  'archive.videos.bloomberg-arrest.title': 'Bloomberg News — Andrew Tate in Rumänien wegen Verdachts auf Menschenhandel und Vergewaltigung festgenommen',
  'archive.videos.bloomberg-arrest.description': 'Der Social-Media-Influencer Andrew Tate wurde Berichten zufolge in Rumänien wegen des Verdachts auf Menschenhandel und Vergewaltigung festgenommen. Der ehemalige Kickboxer wurde zusammen mit seinem Bruder Tristan und zwei weiteren Verdächtigen festgehalten, während sein Haus in der Hauptstadt Bukarest durchsucht wurde.',

  // Video 005
  'archive.videos.uk-case.title': 'Britisches Unterhaus — Debatte „Bekämpfung von Frauenfeindlichkeit an Schulen\u201c, 19. Januar 2023',
  'archive.videos.uk-case.description': 'Offizielle Debatte im britischen Unterhaus mit dem Titel „Tackling Misogyny in Schools\u201c. Abgeordnete diskutierten ausdrücklich den Einfluss von Andrew Tate auf Jungen im Schulalter und verwiesen auf Bedenken von Lehrkräften im ganzen Land, dass seine Inhalte Kinder in Klassenzimmern erreichen. Vollständige offizielle Abschrift über Hansard verfügbar.',

  // Video 006
  'archive.videos.cctv-footage.title': 'ÜBERWACHUNGSKAMERA-AUFNAHMEN \u2014 April 2022',
  'archive.videos.cctv-footage.description': 'Überwachungskamera-Aufnahmen des Anwesens vom April 2022 zeigen Girl A und Girl B, wie sie das Anwesen der Tates frei betreten und verlassen. Die Aufnahmen dokumentieren, dass die beiden Frauen aus eigenem Antrieb kamen und gingen, ohne erkennbare Einschränkung.',

  // Video 007
  'archive.videos.victim-doe-3.title': 'Opfer Doe 3 — Als Opfer geführte Frau bestreitet die Opferrolle und erhebt Korruptionsvorwürfe',
  'archive.videos.victim-doe-3.description': 'Eine Frau, die im rumänischen Fall als Opfer geführt wird, erklärt öffentlich, dass sie kein Opfer ist. Eine von vier Frauen, die sich mit Korruptionsvorwürfen zu den rumänischen Verfahren gegen Andrew und Tristan Tate gemeldet haben. Ihre Aussage stellt die grundlegende Annahme infrage, dass alle namentlich genannten Anzeigenden tatsächlich Opfer waren.',

  // Video 008
  'archive.videos.pencov-statement.title': 'Iasmina Pencov \u2014 Aussage \u201eKein Opfer\u201c \u2014 Januar 2024',
  'archive.videos.pencov-statement.description': 'Iasmina Pencov, die namentlich genannte Klägerin in Pencov v. Doe, erklärt in einem Video vom Januar 2024, dass sie kein Opfer der Tate-Brüder sei und mit der Strafverfolgung nichts zu tun haben wolle.',

  // Video 009
  'archive.videos.online-defamation.title': 'Tate gegen X Corp. — Kontenoffenlegung',
  'archive.videos.online-defamation.description': 'Ein unterzeichneter berichtigter Beschluss wies die geänderte Klage auf reine Beweiserhebung gegen X ohne Präjudiz ab. Die Fallinformation des Clerk zeigte das Verfahren am 4. Oktober 2026 als offen; die zurückgegebene X-Docketliste reicht bis zum 11. September und belegt weder eine spätere Einhaltung der Änderungsfrist noch eine rechtskräftige Abweisung.',

  // Video 010
  'archive.videos.legal-analysis.title': 'Rechtsanalyse und Kommentar',
  'archive.videos.legal-analysis.description': 'Fachkundige Rechtsanalyse der Tate-Verfahren. Kommentare von Anwälten, Verfahrensaufschlüsselungen und investigative Berichterstattung über den mehrstaatlichen Rechtsstreit.',

  // Video 011
  'archive.videos.the-evidence.title': 'Die Beweisübersicht',
  'archive.videos.the-evidence.description': 'Dokumentierte Beweise und Kernfakten. Primärquellen-Dokumente, Gerichtsakten, Zeitachseneinträge und verifizierte öffentliche Aufzeichnungen über alle Gerichtsbarkeiten hinweg.',

  // Video 012
  'archive.videos.tate-protest-history.title': 'Geschichte von Tate Protest',
  'archive.videos.tate-protest-history.description': 'Die Geschichte von Tate Protest als unabhängige Fürsprache-Plattform. Ursprünge, Wachstum, wichtige Meilensteine und das von der Gemeinschaft getragene Bemühen, sachliche Informationen zu dokumentieren und zu teilen.',

  // Video 013
  'archive.videos.media-coverage.title': 'Archiv der Medienberichterstattung',
  'archive.videos.media-coverage.description': 'Zusammenstellung internationaler Medienberichterstattung. Nachrichtensendungen, Interviews, Pressekonferenzen und journalistische Berichterstattung über die Tate-Gerichtsverfahren und die öffentliche Resonanz.',

  // Video 014
  'archive.videos.protest-footage.title': 'Protestaufnahmen',
  'archive.videos.protest-footage.description': 'Dokumentierte friedliche Demonstrationen und öffentliche Versammlungen. Aufnahmen von Protesten, Kundgebungen und öffentlichen Fürsprache-Veranstaltungen zur Unterstützung der Tate-Brüder in mehreren Ländern.',

  // Video 015
  'archive.videos.tate-jack-neel.title': 'Andrew Tates letztes Interview — Podcast mit Jack Neel — Für den Fall einer Festnahme aufgezeichnet',
  'archive.videos.tate-jack-neel.description': 'Andrew Tate trifft sich mit Jack Neel zu dem, was als sein „letztes Interview\u201c beschrieben wurde — eine vorab aufgezeichnete Podcast-Folge, die im Falle seiner Festnahme veröffentlicht werden sollte. Tate spricht offen über die Gerichtsverfahren, die koordinierte Kampagne gegen ihn und seine Botschaft an die Unterstützer, falls er inhaftiert würde.',

  // Video 016
  'archive.videos.vivian-belt-video-statement.title': 'Vivian äußert sich zum geleakten „Gürtel-Video“',
  'archive.videos.vivian-belt-video-statement.description': 'In dieser Videoaussage erklärt Vivian, dass die geleakten Aufnahmen, die als „Gürtel-Video“ bekannt sind, einvernehmliches sexuelles Spiel zeigten. Vivian wurde im Zusammenhang mit der rumänischen Anklage vom September 2026 als eine zentrale mutmaßlich Geschädigte beschrieben. Dieses Archiv gibt ihre Aussage als ihre eigene Darstellung wieder; sie stellt für sich genommen keine gerichtliche Feststellung zu den Vorwürfen dar.',

  // Video 017
  'archive.dates.notProvided': 'Aufnahmedatum nicht angegeben',
  'archive.videos.disruptors-clip.title': 'Tristan spricht über sexuelles Einvernehmen',
  'archive.videos.disruptors-clip.description': 'Tristan Tate spricht über sexuelles Einvernehmen in diesem vom Nutzer bereitgestellten Interviewclip mit einem Disruptors-Wasserzeichen. Das Aufnahmedatum und der ursprüngliche Veröffentlichungslink wurden nicht angegeben.',
  'archive.videos.miami-protest.title': 'Protest in Miami — 27. August 2026',
  'archive.videos.miami-protest.description': 'Eine friedliche Demonstration um 9:00 Uhr EDT am C. Clyde Atkins U.S. Courthouse, 301 North Miami Avenue, Miami, Florida 33128, gefolgt von der Haftprüfung um 10:00 Uhr EDT.',
};